<template>
  <v-container id="project-regions">
    <v-row>
      <v-col class="project-regions__headline">Regionen</v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-chip v-for="r in regionNames" :key="r" class="project-regions__chip">
          {{r}}
        </v-chip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["regionNames"]),
  },
};
</script>
